import i18n from 'i18next';
import detector from 'i18next-browser-languagedetector';

import translationEN from './en/translation.json';
import translationPTBR from './pt-BR/translation.json';
import translationES from './es/translation.json';

const resources = {
  en: { translation: translationEN },
  'pt-BR': { translation: translationPTBR },
  es: { translation: translationES },
};

i18n
  .use(detector)
  .init({
    resources,
    fallbacklng: 'pt-br',
    detection: {
      order: ['path'],
      lookupfrompathindex: 0
    }
  });

global.i18n = i18n;
export default i18n;
